import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import axios from "axios";
import cookie from "react-cookies";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "producttag";
var moduleName = "Tag";
var modulePath = "/clientpanel/catalog-tag";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/catalog-tag/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        productTagName: "",
        productTagImage: "",
        productTagStatus: "",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var productTagStatus =
            result.productTagStatus == "A" ? "Active" : "In Active";
          var status =
            result.productTagStatus !== "" && result.productTagStatus !== null
              ? {
                  label: productTagStatus,
                  value: result.productTagStatus,
                }
              : "";

          var clientupdatedata = {
            productTagName: result.productTagName,
            productTagImage:
              result.productTagImage !== "" && result.productTagImage !== null
                ? result.productTagImage
                : "",
            productTagStatus: status,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid Tag", "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var postObject = {
      productTagName: postData.productTagName,
      productTagImage: postData.productTagImage,
      productTagStatus:postData?.productTagStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-tag"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
function validationConfig(props) {
  const { productTagName, productTagStatus } = props.fields;

  return {
    fields: ["productTagName", "productTagStatus"],

    validations: {
      productTagName: [[isEmpty, productTagName]],
      productTagStatus: [[isSingleSelect, productTagStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  async uplaodFiles() {
    this.props.sateValChange("btndisabled", true);
    showLoader("dz-details", "class");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#productTagImage");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "tag", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange("productTagImage", fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("dz-details", "class");
    $("#productTagImage").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme) {
    showLoader("dz-details", "class");
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader("dz-details", "class");
      this.props.onChange("productTagImage", "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName,
      errMsgStatus = "";
    if ($validation.productTagName.error.reason !== undefined) {
      errMsgName = $validation.productTagName.show && (
        <span className="error">{$validation.productTagName.error.reason}</span>
      );
    }
    if ($validation.productTagStatus.error.reason !== undefined) {
      errMsgStatus = $validation.productTagStatus.show && (
        <span className="error">{$validation.productTagStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-2">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgName !== "" &&
                  errMsgName !== false &&
                  errMsgName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="productTagName"
                value={fields.productTagName}
                {...$field("productTagName", (e) =>
                  onChange("productTagName", e.target.value)
                )}
              />
              <label htmlFor="productTagName">
                Tag Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.productTagStatus}
                onChange={this.handleSelectChange.bind(this, "productTagStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Tag Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="productTagImage"
                  onChange={(event) => {
                    this.uplaodFiles(event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.productTagImage !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.productTagImage} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href={void 0}
                  onClick={this.removeImage.bind(this, fields.productTagImage)}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
